export default __webpack_public_path__ + "static/media/nancy.ff20a4d6.jpg";